(ns dnd.ui.subscription-upgrades
  (:require
    [dnd.analytics :as dnd.analytics]
    [dnd.util :refer [>evt
                      cls]]
    [reagent.core :as r]
    [dnd.constants :refer [api-host
                           session-uuid]]
    [material-ui.core :as m]
    [dnd.domain.model :as domain.model]
    [applied-science.js-interop :as j]
    [austinbirch.reactive-entity :as re]
    [dnd.lang :refer [tr
                    tr-hiccup]]))

(defn ui-upgrade-dialog-plan-box
  [{:keys [name
           label
           currency-code
           plan-id
           monthly?
           token
           price
           chart-limit
           contact-us?]}]
  (let [currency-symbol (condp = currency-code
                          "USD" "$"
                          "GBP" "£"
                          "EUR" "€")]
    [:div {:class (cls "flex"
                       "w-full"
                       "rounded"
                       "mx-2"
                       "flex-col")}
     [:div {:class (cls "px-2 pt-4 pb-1 text-center")}
      [:h2 {:class (cls "text-lg font-semibold")} label]]
     (if contact-us?
       [:div {:class (cls "flex-auto")}
        [:div {:class (cls "text-center py-4 px-4 font-normal text-base leading-normal")}
         (tr-hiccup "If you need more than %{chart-count} charts, please get in touch."
                    {:chart-count [:strong "500"]})]
        [:div {:class (cls "flex-auto")}]]
       (if monthly?
         [:div {:class (cls "p-2 pt-4"
                            "text-center")}
          [:div
           [:h3 {:class (cls "text-4xl text-ochOrange font-bold"
                             "tracking-tighter leading-none")}
            (str currency-symbol price)]
           [:h4 [:span {:class (cls "font-normal")} (tr "per month")]]
           [:div {:class (cls "mt-1")
                  :style {:visibility "hidden"}}
            [:span "_"]]]]
         [:div {:class (cls "p-2 pt-4"
                            "text-center")}
          [:div
           [:h3 {:class (cls "text-4xl text-ochOrange font-bold"
                             "tracking-tighter leading-none")}
            (str currency-symbol price)]
           [:h4 [:span {:class (cls "font-normal")} (tr "per year")]]
           [:div {:class (cls "mt-1")}
            [:span {:class (cls "text-ochOrange text-base font-semibold")} (tr "(save 20%)")]]]]))
     [:div {:class (cls "py-2"
                        "px-4"
                        "flex flex-col"
                        "text-center")}
      (when chart-limit
        [:div
         [:div {:class (cls "mb-1")}
          [:span {:class (cls "font-bold text-2xl")} chart-limit]
          [:div [:span {:class (cls "font-normal text-sm")} (tr "Company Charts")]]]])
      [:div {:class (cls "mt-4")}
       [:div {:class (cls "mb-1")}
        [:span {:class (cls "relative px-2")}
         [:span {:aria-hidden true
                 :class (cls "inline absolute inset-0 bg-yellow-200 transform scale-[1.02] z-[1]"
                             (rand-nth ["-rotate-1"
                                        "-rotate-[1.5deg]"
                                        "rotate-1"
                                        "rotate-[1.5deg]"]))}]
         [:span {:class (cls "relative font-semibold text-sm z-[2]")} (tr "Unlimited Seats")]]]
       [:div {:class (cls "mb-1")} [:span {:class (cls "font-normal text-sm")} (tr "Account Mapping Functionality")]]]]
     (if contact-us?
       [:div {:class (cls "py-4 px-2")}
        [:> m/Button
         {:variant "contained"
          :color "primary"
          :style {:text-transform "none"}
          :fullWidth true
          :onClick (fn []
                     (when-let [widget (j/get-in js/window ["HubSpotConversations" "widget"])]
                       (.open widget)))}
         (tr "Speak to us")]]
       (let [url (domain.model/make-checkout-link
                   {:plan-id plan-id
                    :token token})]
         [:div {:class (cls "py-4 px-2")}
          [:> m/Button
           {:variant "contained"
            :color "primary"
            :fullWidth true
            :style {:text-transform "none"}
            :onClick (fn []
                       (>evt [:events.analytics/log-event
                              {:event (dnd.analytics/make-event-upgrade-dialog-upgrade-button-clicked
                                        {:plan-id plan-id
                                         :plan-name name
                                         :currency-code currency-code
                                         :billing-cycle (if monthly?
                                                          "monthly"
                                                          "annual")
                                         :price price})}])
                       (.open js/window url "_blank"))}
           (tr "Upgrade")]]))]))

(defn ui-upgrade-dialog
  []
  (let [state (r/atom {:annual-billing false
                       :overridden-currency-code nil})]
    (fn []
      (let [<session (re/entity [:uuid session-uuid])
            currency-code (or (:overridden-currency-code @state)
                              (:session/currency-code <session)
                              "USD")
            plans [{:name "Basic 50"
                    :label "Basic 50"
                    :chart-limit "50"
                    :prices [{:currency-code "USD"
                              :monthly-price 120
                              :annual-price (* 96 12)
                              :monthly-plan-id "price_1N6cfeIAT5kT14ymlLrMkuPC"
                              :annual-plan-id "price_1N6cffIAT5kT14ym1wdBOJ7B"}
                             {:currency-code "EUR"
                              :monthly-price 110
                              :annual-price (* 88 12)
                              :monthly-plan-id "price_1N6cfeIAT5kT14ymaH6Of7lc"
                              :annual-plan-id "price_1N6ce2IAT5kT14ymmLW0aA6y"}
                             {:currency-code "GBP"
                              :monthly-price 95
                              :annual-price (* 76 12)
                              :monthly-plan-id "price_1N6cfeIAT5kT14ymmvxzn6ct"
                              :annual-plan-id "price_1N6cffIAT5kT14ymY49GKONv"}]}
                   {:name "Pro 100"
                    :label "Pro 100"
                    :chart-limit "100"
                    :prices [{:currency-code "USD"
                              :monthly-price 158
                              :annual-price (* 126 12)
                              :monthly-plan-id "price_1N6cffIAT5kT14ymj6ydbBUu"
                              :annual-plan-id "price_1N6cfgIAT5kT14ymqVRXcJiL"}
                             {:currency-code "EUR"
                              :monthly-price 145
                              :annual-price (* 115 12)
                              :monthly-plan-id "price_1N6cfgIAT5kT14ym6iI5PSLm"
                              :annual-plan-id "price_1N6cfhIAT5kT14ymlntuSos3"}
                             {:currency-code "GBP"
                              :monthly-price 126
                              :annual-price (* 100 12)
                              :monthly-plan-id "price_1N6cfgIAT5kT14ymrYKNEGXf"
                              :annual-plan-id "price_1N6cfhIAT5kT14ymEmxOmmHc"}]}
                   {:name "Pro 250"
                    :label "Pro 250"
                    :chart-limit "250"
                    :prices [{:currency-code "USD"
                              :monthly-price 220
                              :annual-price (* 176 12)
                              :monthly-plan-id "price_1N6cfhIAT5kT14ymw2UbFJyA"
                              :annual-plan-id "price_1N6cfiIAT5kT14ymTcd84jbs"}
                             {:currency-code "EUR"
                              :monthly-price 200
                              :annual-price (* 160 12)
                              :monthly-plan-id "price_1N6cfiIAT5kT14ymbkvMtkDO"
                              :annual-plan-id "price_1N6cfjIAT5kT14ymqCpbx4R9"}
                             {:currency-code "GBP"
                              :monthly-price 175
                              :annual-price (* 140 12)
                              :monthly-plan-id "price_1N6cfiIAT5kT14ymvm75Z1xx"
                              :annual-plan-id "price_1N6cfiIAT5kT14ymAicq7vDf"}]}
                   {:name "Pro 500"
                    :label "Pro 500"
                    :chart-limit "500"
                    :prices [{:currency-code "USD"
                              :monthly-price 265
                              :annual-price (* 212 12)
                              :monthly-plan-id "price_1N6cfjIAT5kT14ym0Py26YFN"
                              :annual-plan-id "price_1N6cfkIAT5kT14ymbi6pQaJe"}
                             {:currency-code "EUR"
                              :monthly-price 242
                              :annual-price (* 194 12)
                              :monthly-plan-id "price_1N6cfjIAT5kT14ymjj3kVrFO"
                              :annual-plan-id "price_1N6cfkIAT5kT14ymIEGiiwv1"}
                             {:currency-code "GBP"
                              :monthly-price 211
                              :annual-price (* 168 12)
                              :monthly-plan-id "price_1N6cfjIAT5kT14ymtAnJPQ48"
                              :annual-plan-id "price_1N6cfkIAT5kT14ym3BtryeZ3"}]}
                   {:name "Contact Us"
                    :label (tr "Contact Us")
                    :contact-us? true}]
            monthly? (not (:annual-billing @state))
            make-plan-block-def (fn [{:keys [plan-name]}]
                                  (let [plan (->> plans
                                                  (filter (fn [plan]
                                                            (= (:name plan) plan-name)))
                                                  first)
                                        price (->> (:prices plan)
                                                   (filter (fn [price]
                                                             (= (:currency-code price) currency-code)))
                                                   first)]

                                    {:token (:session/token <session)
                                     :currency-code currency-code
                                     :plan-id (if monthly?
                                                (:monthly-plan-id price)
                                                (:annual-plan-id price))
                                     :name (:name plan)
                                     :label (:label plan)
                                     :monthly? monthly?
                                     :price (if monthly?
                                              (:monthly-price price)
                                              (:annual-price price))
                                     :chart-limit (:chart-limit plan)
                                     :contact-us? (boolean (:contact-us? plan))}))]
        [:> m/Dialog
         {:open (boolean (:session.och/upgrade-dialog-visible? <session))
          :fullWidth true
          :maxWidth "lg"
          :onClose (fn []
                     (>evt [:events.och.upgrade-dialog/hide]))}
         [:div {:class (cls "flex" "flex-col")}
          [:div {:class (cls "flex flex-row justify-between pt-4 px-8")}
           [:> m/Select
            {:value currency-code
             :onChange (fn [e]
                         (swap! state assoc
                                :overridden-currency-code (j/get-in e ["target" "value"])))}
            [:> m/MenuItem {:disabled true :value ""}
             [:em "Currency"]]
            [:> m/MenuItem {:value "USD"}
             [:div {:class (cls "flex flex-row items-center")}
              [:div {:class (cls "currency-flag currency-flag-usd mr-2")}]
              "USD"]]
            [:> m/MenuItem {:value "GBP"}
             [:div {:class (cls "flex flex-row items-center")}
              [:div {:class (cls "currency-flag currency-flag-gbp mr-2")}]
              "GBP"]]
            [:> m/MenuItem {:value "EUR"}
             [:div {:class (cls "flex flex-row items-center")}
              [:div {:class (cls "currency-flag currency-flag-eur mr-2")}]
              "EUR"]]]
           [:span
            [:> m/Grid
             {:component "label"
              :container true
              :alignItems "center"
              :spacing 1}
             [:> m/Grid {:item true}
              [:span {:class (cls "text-base font-normal"
                                  (when (not (:annual-billing @state))
                                    "font-semibold"))}
               (tr "Monthly")]]
             [:> m/Switch
              {:checked (:annual-billing @state)
               :onChange (fn []
                           (let [from (if (:annual-billing @state)
                                        "annual"
                                        "monthly")
                                 to (if (:annual-billing @state)
                                      "monthly"
                                      "annual")]
                             (>evt [:events.analytics/log-event
                                    {:event (dnd.analytics/make-event-upgrade-dialog-switched-billing-cycle
                                              {:from from
                                               :to to})}]))
                           (swap! state update :annual-billing not))
               :value "annual"}]
             [:> m/Grid {:item true}
              [:span {:class (cls "text-base font-normal"
                                  (when (:annual-billing @state)
                                    "font-semibold"))}
               (tr "Annual ") [:span {:class (cls "text-ochOrange font-semibold")} "(save 20%)"]]]]]]
          [:div {:class (cls "flex flex-row p-4")}
           [ui-upgrade-dialog-plan-box (make-plan-block-def {:plan-name "Basic 50"})]
           [:div {:style {:width "2px"
                          :flex-grow 0
                          :flex-shrink 0}
                  :class (cls "bg-black bg-opacity-10")}]
           [ui-upgrade-dialog-plan-box (make-plan-block-def {:plan-name "Pro 100"})]
           [:div {:style {:width "2px"
                          :flex-grow 0
                          :flex-shrink 0}
                  :class (cls "bg-black bg-opacity-10")}]
           [ui-upgrade-dialog-plan-box (make-plan-block-def {:plan-name "Pro 250"})]
           [:div {:style {:width "2px"
                          :flex-grow 0
                          :flex-shrink 0}
                  :class (cls "bg-black bg-opacity-10")}]
           [ui-upgrade-dialog-plan-box (make-plan-block-def {:plan-name "Pro 500"})]
           [:div {:style {:width "2px"
                          :flex-grow 0
                          :flex-shrink 0}
                  :class (cls "bg-black bg-opacity-10")}]
           [ui-upgrade-dialog-plan-box (make-plan-block-def {:plan-name "Contact Us"})]]]]))))
